import React, { useState, useEffect } from "react";
import { Flex, FlexLeftColNoGap } from "styles/global-style";
import Task from "./Task";
import { Droppable } from "@hello-pangea/dnd";

import check from "imgs/check.png";

export default function Column({ indexPath, col, index, storyIndex, storyId, width, isFirst, showAdd, addTaskCb, editTaskCb, users, usersForDisplay, isEndColumn, selectedStory, selectedTask, totalStories, tasks, editingTaskId, onSaveTaskTitle, onSaveTaskEstimate, onSaveTaskAssignee, isCompleted }) {
  const [isMinimized, setIsMinimized] = useState(isEndColumn && tasks?.length > 4);
  const [isHoveringAddTask, setIsHoveringAddTask] = useState(false);
  const isMac = navigator.platform.toUpperCase().indexOf("MAC") >= 0;

  // Reset hover state when showAdd changes to prevent flash
  useEffect(() => {
    if (!showAdd) {
      setIsHoveringAddTask(false);
    }
  }, [showAdd]);

  const getStyle = (isDraggingOver) => ({
    background: isDraggingOver ? "#ffffff22" : "none",
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    flexGrow: 1,
    marginTop: 2,
  });

  return (
    <FlexLeftColNoGap
      style={{
        minWidth: 180,
        width: width + "%",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          paddingLeft: 6,
          background: isCompleted ? "#a6ff0088" : "#ffffff44",
          backdropFilter: "blur(2px)",
          opacity: 0.6,
          fontSize: 10,
          height: 20,
          borderRadius: 2,
          boxShadow: "#000000 1px 1px 3px",
          fontWeight: "bold",
          userSelect: "none",
          color: isCompleted ? "#a6ff00" : "#fff",
        }}
      >
        {col.title}
      </div>

      <Droppable droppableId={indexPath.join("-")} type="task">
        {(provided, snapshot) => (
          <div
            key={indexPath.join("-")}
            {...provided.droppableProps}
            ref={provided.innerRef}
            style={getStyle(snapshot.isDraggingOver)}
            onClick={() => {
              if (isEndColumn) setIsMinimized(false);
            }}
            onMouseLeave={() => {
              if (isEndColumn && tasks?.length > 4 && !snapshot.isDraggingOver) setIsMinimized(true);
            }}
          >
            {isMinimized &&
              tasks &&
              tasks.map((task, i) => {
                return (
                  <Flex key={"minimizedTask" + i} style={{ justifyContent: "center", flexGrow: "none", background: isCompleted ? "rgba(130, 197, 7, 0.2)" : "white", height: 30, width: 45, borderRadius: 4, margin: 3 }}>
                    <img alt="check" src={check} style={{ height: 14, filter: isCompleted ? "sepia(1) saturate(3) hue-rotate(60deg)" : undefined }} />
                  </Flex>
                );
              })}

            {!isMinimized &&
              tasks &&
              tasks.length > 0 &&
              tasks.map((task, k) => {
                const displayUsers = usersForDisplay && usersForDisplay.length > 0 ? usersForDisplay : users;
                const _user = displayUsers.find((usr) => usr.id === task.owner_id);
                return (
                  <Task
                    indexPath={[...indexPath, k]}
                    key={[...indexPath, k].join("-")}
                    id={task.id}
                    task={task}
                    title={task.title}
                    index={k}
                    clickTaskCb={(task, isTitleClick) => editTaskCb(task, isTitleClick)}
                    user={_user}
                    selected={selectedTask === k && selectedStory === storyIndex}
                    isEditing={editingTaskId === task.id}
                    onSaveTitle={onSaveTaskTitle}
                    users={users}
                    onSaveEstimate={onSaveTaskEstimate}
                    onSaveAssignee={onSaveTaskAssignee}
                    isCompleted={isCompleted}
                  />
                );
              })}
            {provided.placeholder}
            {!isCompleted && isFirst && ((showAdd && !snapshot.isDraggingOver) || selectedStory === storyIndex || (totalStories === 1 && storyIndex === 0 && (!tasks || tasks.length === 0))) ? (
              <div
                style={{
                  position: "relative",
                  background: isCompleted 
                    ? (isHoveringAddTask ? "rgba(130, 197, 7, 0.3)" : "rgba(130, 197, 7, 0.1)")
                    : (isHoveringAddTask ? "rgba(233, 236, 239, 0.4)" : "rgba(248, 249, 250, 0.05)"),
                  borderColor: isCompleted ? (isHoveringAddTask ? "#82c507" : "#a6ff0088") : (isHoveringAddTask ? "#999" : "#ccc"),
                  borderRadius: 5,
                  padding: "9px 11px",
                  margin: 3,
                  userSelect: "none",
                  height: 6,
                  cursor: "pointer",
                  color: isCompleted ? (isHoveringAddTask ? "#82c507" : "white") : (isHoveringAddTask ? "#333" : "#888"),
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transition: "background 0.2s ease, border-color 0.2s ease",
                }}
                onMouseEnter={() => setIsHoveringAddTask(true)}
                onMouseLeave={() => setIsHoveringAddTask(false)}
                onClick={() => {
                  if (addTaskCb) addTaskCb(storyId, storyIndex, col.id, index);
                }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: 8, userSelect: "none" }}>
                  <div style={{ fontSize: 16, fontWeight: "bold", marginBottom: 3, userSelect: "none"}}>+</div>
                  <div style={{ fontSize: 12, fontWeight: 500, userSelect: "none", WebkitUserSelect: "none", MozUserSelect: "none", msUserSelect: "none" }}>
                    {selectedStory === storyIndex ? `Add Task (${isMac ? "⌘+Enter" : "Ctrl+Enter"})` : "Add Task"}
                  </div>
                </div>
              </div>
            ) : isFirst && !isCompleted ? <div style={{ height: 24, margin: 3, userSelect: "none" }} /> : null}
          </div>
        )}
      </Droppable>
    </FlexLeftColNoGap>
  );
}
